// extracted by mini-css-extract-plugin
export default {"mixedText":"BackGround_mixedText__Ds1NY","sectionContent":"BackGround_sectionContent__DM6fH","knmMe":"BackGround_knmMe__Bvoas","separator":"BackGround_separator__PLxhP"};